export const REQUIRED_FIELDS_NOT_FILLED_TIP = "You must choose all required values to continue.";
export const PARENT_AND_CHILD_MARKET_REQUIRED_TIP = "You must choose a Parent Market and at least one Child Market to continue.";

export const ACCESS_LEVELS_THAT_HIDE_EMPTY_MARKET_NODES: Partial<AccessLevel>[] = ['retailer', 'all_else', 'unknown', 'banks_finance', 'consulting', 'thc'];